import { LIFE_CYCLE_EVENT_BUS } from 'life-cycle-event-bus';
import Bowser from 'bowser';

if(location.search.indexOf('debug') !== -1){
    window.isDebugMode = true;
}

const browser = Bowser.getParser(window.navigator.userAgent);
const isValidBrowser = browser.satisfies({
    macos: {
        safari: ">12.1"
    },
    mobile: {
        safari: '>=11',
    }
});

if((browser.getBrowserName() === 'Safari' && !isValidBrowser) || !navigator.cookieEnabled) {
    document.addEventListener('DOMContentLoaded', function() {
        const head = document.getElementsByTagName('head')[0];
        const lazyCSS = document.createElement('link');
        const lazyJS = document.createElement('script');

        lazyCSS.href = 'https://assets.thdstatic.com/core/vanilla-overlay/v1.0.11/main.css';
        lazyCSS.rel = 'stylesheet';
        lazyCSS.type = 'text/css';
        lazyJS.type = 'text/javascript';
        lazyJS.onload = function() {
            vanilla_overlay.openOverlay();
        }
        lazyCSS.onload = function() {
            lazyJS.src = 'https://assets.thdstatic.com/core/vanilla-overlay/v1.0.11/index.min.js';
            head.appendChild(lazyJS);
        }
        head.appendChild(lazyCSS);

    });
}

window.LIFE_CYCLE_EVENT_BUS = LIFE_CYCLE_EVENT_BUS;
window.waitForEvent = function(event) {
    return new Promise(resolve => window.LIFE_CYCLE_EVENT_BUS.lifeCycle.on(event, resolve));
};
